import React from 'react';
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../../redux/actions/app';
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { capitalize } from 'lodash';
import {
  NS_POST_CREATE_TICKET,
  postCreateTicketForChampionSuccess,
  postCreateTicketForChampionFail,
  NS_GET_CURRENT_CHAMPION,
  getCurrentChampionSuccess,
  getCurrentChampionFail,
  getChampionChallengerDetailsFail,
  getChampionChallengerDetailsSuccess,
  NS_GET_CHAMPION_CHALLENGER_DETAILS,
  getChampionChallengerDetails
} from '../../redux/actions/ns/tickets';

import {
  postCreateTicketForChampionService,
  getCurrentChampionService
} from '../../services/ns/tickets';
import { ROUTE_AMLS_SMART_SCREENING } from '../../pages/constants/globalConstants';
import { getNSRunInstanceSummaryService } from '../../services/ns/runInstance';

/***
 * Post Create Ticket
 ***/
function* postCreateTicketForChampionWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(postCreateTicketForChampionService, payload);
    if (response?.status === 200 || response?.status === 201) {
      notification.open({
        message: (
          <p>
            <i style={{ color: '#2ecc71' }} className="fa fa-check"></i>
            &nbsp;&nbsp;Success
          </p>
        ),
        description: `A ticket for the ${payload?.challengerName} has been created successfully.`
      });
      yield put(postCreateTicketForChampionSuccess(response.data));
      yield put(push(`${ROUTE_AMLS_SMART_SCREENING}/runInstance?tab=1`));
      yield put(ga.fetchSuccess());
    } else throw { errorMessage: response?.data?.msg };
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
    yield put(postCreateTicketForChampionFail({ error: error.errorMessage }));
    yield put(ga.fetchFailed({ error: error.errorMessage }));
  }
}

export function* watchPostCreateTicketForChampion() {
  yield takeEvery(NS_POST_CREATE_TICKET, function* ({ payload }) {
    yield fork(postCreateTicketForChampionWorker, payload);
  });
}

/***
 * Get Current Champion
 ***/
function* getCurrentChampionWorker(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const { payload: sourceId } = payload;
    const response = yield call(getCurrentChampionService, sourceId);
    if (response?.status === 200) {
      yield put(getCurrentChampionSuccess(response.data));
      yield put(ga.fetchSuccess());
      yield put(
        getChampionChallengerDetails({ id: response.data, key: 'champion' })
      );
    } else if (response?.status === 404) {
      yield put(getCurrentChampionSuccess('NO CURRENT CHAMPION FOUND'));
      yield put(ga.fetchSuccess());
    } else {
      throw { errorMessage: response?.data?.msg };
    }
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error?.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getCurrentChampionFail({ error }));
  }
}

export function* watchGetCurrentChampion() {
  yield takeEvery(NS_GET_CURRENT_CHAMPION, function* (payload) {
    yield fork(getCurrentChampionWorker, payload);
  });
}

/***
 * Get Champion Challenger Details
 ***/
function* getChampionChallengerDetailsWorker(payload) {
  try {
    const { id, key } = payload;
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(getNSRunInstanceSummaryService, { id });
    yield put(
      getChampionChallengerDetailsSuccess({
        data: { [key]: response },
        loading: { [`is${capitalize(key)}Loading`]: false }
      })
    );
    yield put(ga.fetchSuccess());
  } catch (error) {
    notification.open({
      message: (
        <p>
          <i style={{ color: '#e74c3c' }} className="fa fa-close"></i>
          &nbsp;&nbsp;{' '}
          {error?.errorMessage ? error?.errorMessage : 'Something went wrong !'}
        </p>
      ),
      description: 'Please try after sometime.'
    });
    yield put(ga.fetchFailed({ error: '' }));
    yield put(
      getChampionChallengerDetailsFail({
        error: { error },
        loading: { [`is${capitalize(key)}Loading`]: false }
      })
    );
  }
}

export function* watchGetChampionChallengerDetails() {
  yield takeEvery(NS_GET_CHAMPION_CHALLENGER_DETAILS, function* ({ payload }) {
    yield fork(getChampionChallengerDetailsWorker, payload);
  });
}
